<template>
  <div id="index">
    <!-- <Hezuo></Hezuo> -->

    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i
          class="esc"
          @click="goBackward"
        ><img
            src="@/assets/img/esc_fan.png"
            alt=""
          ></i>
        <h4 class="header_title">消息列表</h4>
      </header>
      <!-- 内容 -->
      <div
        class='comments_ul'
        v-if="list_arr.length>0"
      >
        <div
          class="comments_li"
          @click="read(liem)"
          :class="[{'unread':liem.read == 0 }]"
          v-for="liem in list_arr"
        >
          <div class="user_text flex_between">
            <span class="user_name">系统消息</span>
            <span class="time">{{liem.create_time}}</span>
          </div>
          <div
            class="text_center clamp1"
            v-html="liem.content"
          >
          </div>
        </div>
      </div>
       <div class="claloadding" v-if="loaidin">
          <div>
            <img
              src="@/assets/img/loadding_pc.gif"
              alt=""
            >
          </div>
          <div>努力加载中...</div>
        </div>
      <div
        class="complete"
        v-if="list_arr.length===0&&!loaidin"
      >
        <div class="claloadding">
          <div>
            <img
              src="@/assets/img/kkry_pc.gif"
              alt=""
            >
          </div>
          <div>空空如也...</div>
        </div>
       
      </div>

    </div>
  </div>
</template>

<script>
import Hezuo from '@/components/tool/m_hezuo.vue'

export default {
  name: "index",
  data () {
    return {
      user: {},//用户信息
      list_arr: [],
      page: 1,
      loaidin:true
    };
  },
  computed: {

  },
  components: {
    Hezuo
  },
  watch: {

  },
  methods: {
    read (liem) {
      this.$router.push({ path: '/m_message_details', query: liem });
    },
    goBackward () {//返回上一页
      this.$router.go(-1)
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();

      that.user = this.USER();
      that.getList();
    },
    getList () {//获取列表数据
      let that = this;
      if (this.page == 1) {
        this.list_arr = [];
      }
      this.$get('system_message', {
        member_id: this.USER().id,
        limit: 10,
        page: this.page,
      }).then(res => {
        this.loaidin=false
        that.list_arr = that.list_arr.concat(res.data.data);

      })
    },

  },
  mounted () {
    this.getUser();
    this.getShare();


    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getList();
      }
    });
  }
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */

/* 消息记录 */
.comments_ul {
}

.comments_ul .comments_li {
  position: relative;
  padding: 1.1rem 2.3rem;
  border-bottom: 0.05rem solid #dfdfdf;
}

.comments_li .user_text .user_name {
  font-size: 1.4rem;
  color: #333;
  line-height: 1.1em;
}

.comments_li .user_text .time {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.1em;
}

.comments_li .text_center {
  margin-top: 0.8rem;
  font-size: 1.2rem;
  color: #333;
  line-height: 1.6em;
}

.comments_ul .comments_li.unread::after {
  position: absolute;
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  top: 1.4rem;
  left: 1.5rem;
  background: #f24d5b;
}
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_message.vue